<template>
  <div id="appmenu">
	<div class=" header" cpid="30459" id="smv_Area0" style="width: 1200px; height: 70px;  position: relative; margin: 0 auto">
	<div id="smv_tem_69_51" ctype="banner"  class="esmartMargin smartAbs " cpid="30459" cstyle="Style2" ccolor="Item0" areaId="Area0" isContainer="True" pvid="" tareaId="Area0"  re-direction="y" daxis="Y" isdeletable="True" style="height: 70px; width: 100%; left: 0px; top: 0px;z-index:4;">
	<div class="yibuFrameContent tem_69_51  banner_Style2  " style="overflow:visible;;" >
	<div class="fullcolumn-inner smAreaC" id="smc_Area0" cid="tem_69_51" style="width:1200px">
	<!--logo-->
	<div id="smv_tem_70_40" ctype="logoimage"  class="esmartMargin smartAbs " cpid="30459" cstyle="Style1" ccolor="Item0" areaId="Area0" isContainer="False" pvid="tem_69_51" tareaId="Area0"  re-direction="all" daxis="All" isdeletable="True" style="height: 40px; width: 147px; left: 1px; top: 18px;z-index:2;">
	<div class="yibuFrameContent tem_70_40  logoimage_Style1  " style="overflow:visible;;" >
	<div class="w-image-box" data-fillType="0" id="div_tem_70_40">
		<a target="_self" href="/">
			<img src="/image/logo.png" alt="" title="" id="img_smv_tem_70_40" style="width: 147px; height:40px;">
		</a>
	</div>
	</div>
	</div>
	<!--logo end-->
	<!--menu begin-->
	<div id="smv_tem_71_19" ctype="nav"  class="esmartMargin smartAbs " cpid="30459" cstyle="Style4" ccolor="Item0" areaId="Area0" isContainer="False" pvid="tem_69_51" tareaId="Area0"  re-direction="all" daxis="All" isdeletable="True" style="height: 70px; width: 626px; left: 570px; top: 0px;z-index:3;">
		<div class="yibuFrameContent tem_71_19  nav_Style4  " style="overflow:visible;;" >
			<div id="nav_tem_71_19" class="nav_pc_t_4">
				<ul class="w-nav" navstyle="style4">
					<li class="sliding-box" style="height:70px;left:-0px;top:-0px">
					<div class="sliding" style="height:70px;width:20%"></div>
					</li>
					<li class="w-nav-inner" style="height:70px;line-height:70px;width:20%;left:220px">
						<div class="w-nav-item">
							<a href="/" target="_self" class="w-nav-item-link">
								<span class="mw-iconfont"></span>
								<span class="w-link-txt" style="font-size: 22px;">首页</span>
							</a>
						</div>
					</li>
					<li class="w-nav-inner" style="height:70px;line-height:70px;width:20%;left:220px">
						<div class="w-nav-item">
							<a href="/about" target="_self" class="w-nav-item-link">
								<span class="mw-iconfont"></span>
								<span class="w-link-txt" style="font-size: 22px;">关于我们</span>
							</a>
						</div>
					</li>
					<li class="w-nav-inner" style="height:70px;line-height:70px;width:20%;left:220px">
						<div class="w-nav-item">
							<a href="/product" target="_self" class="w-nav-item-link">
								<span class="mw-iconfont"></span>
								<span class="w-link-txt" style="font-size: 22px;">产品系列</span>
							</a>
						</div>
					</li>
					<!--
					<li class="w-nav-inner" style="height:70px;line-height:70px;width:20%;">
						<div class="w-nav-item">
							<a href="/yyal" target="_self" class="w-nav-item-link">
								<span class="mw-iconfont"></span>
								<span class="w-link-txt">应用案例</span>
							</a>
						</div>
					</li>
					<li class="w-nav-inner" style="height:70px;line-height:70px;width:20%;">
						<div class="w-nav-item">
							<a href="/hyzx" target="_self" class="w-nav-item-link">
								<span class="mw-iconfont"></span>
								<span class="w-link-txt">行业资讯</span>
							</a>
						</div>
					</li>
					-->
				</ul>
			</div>
		</div>
	</div>
	<!--menu end-->
	</div>
	<div id="bannerWrap_tem_69_51" class="fullcolumn-outer" style="position: absolute; top: 0px; bottom: 0px;"></div>
	</div>
	</div>
	</div>
  </div>
</template>

<script>
export default {
  name: 'appmenu'
}
</script>

<style>

</style>
